import { FC } from 'react';
import { CollapseProps } from './interface';
import { Collapse } from '@arco-design/web-react';
import { showText } from '@shared/assets/svg/base';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import styles from './index.module.less';

const CollapseItem = Collapse.Item;

const pc: FC<CollapseProps> = ({ iconPositon = 'left', data }) => {
	return (
		<Collapse
			className={styles.a1override}
			bordered={false}
			style={{ maxWidth: 1180 }}
			expandIconPosition={iconPositon}
			expandIcon={<NewBaseIcon size={24} icon={showText} color="#000" />}
		>
			{data.map((item, index) => (
				<CollapseItem header={item.title} name={index.toString()} key={index}>
					{item.content}
				</CollapseItem>
			))}
		</Collapse>
	);
};

export default pc;
